import Coins from "@/views/admin/coins/Coins";

export default {
  path: "coins",
  component: Coins,
  name: "admin-coins-charge",
};
